export * as AiAsstWmTypes from './swagger/aiAsstWm/types';
export var AiAsstWmChatMsgType;
(function (AiAsstWmChatMsgType) {
    AiAsstWmChatMsgType["COMMAND"] = "COMMAND";
    AiAsstWmChatMsgType["RESPONSE"] = "RESPONSE";
})(AiAsstWmChatMsgType || (AiAsstWmChatMsgType = {}));
export var AiAsstWmChatMsgStatus;
(function (AiAsstWmChatMsgStatus) {
    AiAsstWmChatMsgStatus["PENDING"] = "PENDING";
    AiAsstWmChatMsgStatus["FINISH"] = "FINISH";
    AiAsstWmChatMsgStatus["ERROR"] = "ERROR";
})(AiAsstWmChatMsgStatus || (AiAsstWmChatMsgStatus = {}));
export var AiAsstWmBizType;
(function (AiAsstWmBizType) {
    AiAsstWmBizType["EMAIL_SUMMARY"] = "EMAIL_SUMMARY";
    AiAsstWmBizType["EMAIL_REPLY"] = "EMAIL_REPLY";
    AiAsstWmBizType["AI_QUESTION"] = "AI_QUESTION";
    AiAsstWmBizType["PROACTIVE_GUIDE"] = "PROACTIVE_GUIDE";
})(AiAsstWmBizType || (AiAsstWmBizType = {}));
export var AiAsstWmSubBizType;
(function (AiAsstWmSubBizType) {
    AiAsstWmSubBizType["AI_SEARCH"] = "AI_SEARCH";
})(AiAsstWmSubBizType || (AiAsstWmSubBizType = {}));
export var AiAsstWmChatMsgFinishReason;
(function (AiAsstWmChatMsgFinishReason) {
    AiAsstWmChatMsgFinishReason["STOP"] = "STOP";
    AiAsstWmChatMsgFinishReason["LENGTH"] = "LENGTH";
    AiAsstWmChatMsgFinishReason["CONTENT_FILTER"] = "CONTENT_FILTER";
    AiAsstWmChatMsgFinishReason["USER"] = "USER";
})(AiAsstWmChatMsgFinishReason || (AiAsstWmChatMsgFinishReason = {}));
export var AiAsstWmChatMsgFeedback;
(function (AiAsstWmChatMsgFeedback) {
    AiAsstWmChatMsgFeedback["UP_VOTE"] = "UP_VOTE";
    AiAsstWmChatMsgFeedback["DOWN_VOTE"] = "DOWN_VOTE";
})(AiAsstWmChatMsgFeedback || (AiAsstWmChatMsgFeedback = {}));
export var AiAsstWmInnerAbortReason;
(function (AiAsstWmInnerAbortReason) {
    AiAsstWmInnerAbortReason["MsgError"] = "MsgError";
    AiAsstWmInnerAbortReason["CatchedError"] = "CatchedError";
})(AiAsstWmInnerAbortReason || (AiAsstWmInnerAbortReason = {}));
